import React from "react";

/**
 * Renders a boxer-brief product image, scaled to fit its container.
 *
 * Props:
 *  - src:       image URL (individual product photo)
 *  - alt:       accessible label
 *  - className: extra classes for the wrapper
 *  - fit:       "contain" (default) or "cover"
 */
export default function ProductImage({
  src,
  alt = "BD Boxer Brief",
  className = "",
  fit = "contain",
  style = {},
}) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        width: "100%",
        height: "100%",
        objectFit: fit,
        objectPosition: "center",
        display: "block",
        ...style,
      }}
      loading="lazy"
    />
  );
}
